import { Benefit } from 'src/models/Benefit/Benefit';
import { DiscountChip } from 'src/components/DiscountChip';
import sanitizeHtml from 'src/utils/sanitizeHtml';

import {
  Card,
  Layout,
  Image,
  Content,
  Title,
  ChipRow,
  Description,
  SkeletonBlock,
} from './styles';

export const BenefitCardlet: React.FC<{
  benefit?: Benefit;
}> = ({ benefit }) => {
  if (!benefit) {
    return (
      <div>
        <Layout>
          <SkeletonBlock style={{ paddingTop: '125%' }} />
          <Content>
            <SkeletonBlock style={{ height: 23 }} />
            <SkeletonBlock style={{ height: 36, marginTop: 4 }} />
          </Content>
        </Layout>
      </div>
    );
  }

  return (
    <Card to={`/benefits/${benefit.id}`}>
      <Layout>
        <Image>
          {benefit.image && <img src={benefit.image} alt="" />}
        </Image>
        <Content>
          <Title>{benefit.name}</Title>
          {benefit.discount && (
            <ChipRow>
              <DiscountChip label={benefit.discount} />
            </ChipRow>
          )}
          {benefit.description && (
            <Description
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(benefit.description, { stripLinks: true }),
              }}
            />
          )}
        </Content>
      </Layout>
    </Card>
  );
};

export default BenefitCardlet;
